import {useAppNotificationContext} from '../../services/notification/AppNotificationProvider';

export const useOpenNotification = () => {
  const {
    openInfoNotification,
    openErrorNotification,
    openSuccessNotification,
    openWarningNotification,
  } = useAppNotificationContext();

  return {
    openInfoNotification,
    openErrorNotification,
    openSuccessNotification,
    openWarningNotification,
  };
};
